<script>
export default {
  data() {
    return {
      show: true,
    }
  },
  watch: {
    '$page.props.flash': {
      handler() {
        this.show = true
      },
      deep: true,
    },
  },
}
</script>

<script setup>
import { onMounted, ref } from 'vue'
import { Link } from '@inertiajs/inertia-vue3'
import useIntersectionObserver from '@/Shared/useIntersectionObserver.js'
import ButtonClose from '@/Shared/Buttons/ButtonClose'
import { setCookie, getCookie } from '@/Shared/helper.js'

const props = defineProps({
  news: Object,
})

const footerIn = ref(false)
const newsVisible = ref()

const onClose = () => {
  newsVisible.value = false
  setCookie('af_news_visible', 'hidden', 60 * 60 * 1)
}

const updateNewsVisible = () => {
  if (getCookie('af_news_visible')) {
    newsVisible.value = getCookie('af_news_visible') === 'hidden' ? false : true
  } else {
    newsVisible.value = true
  }
}

const observeFooter = () => {
  useIntersectionObserver({
    target: document.querySelector('.footer'),
    rootMargin: '-100px',
    onEnter: () => {
      footerIn.value = true
    },
    onLeave: () => {
      footerIn.value = false
    },
  })
}

onMounted(() => {
  if (!props.news) return
  updateNewsVisible()
  observeFooter()
})
</script>

<template>
  <template v-if="props.news || show">
    <div class="text-[85%] text-white font-medium [&>div]:z-50 [&>div]:p-[10px] [&_.wrapper]:p-[10px] [&_.wrapper]:flex [&_.wrapper]:items-center [&_.wrapper]:justify-center [&_.wrapper]:rounded-[5px] [&_p]:grow [&_p]:leading-[1.4] [&_p]:mr-[10px] [&_svg]:mr-[8px] [&_svg]:w-[15px] [&_svg]:h-[15px] [&_svg]:fill-white [&_.btn-close]:p-[15px] [&_.btn-close]:m-[-10px] [&_.btn-close]:scale-90 [&_.btn-close]:overflow-hidden [&_.btn-close]:relative">
      <!-- news -->
      <template v-if="props.news && newsVisible && !footerIn">
        <div class="fixed bottom-0 !p-0 xl:!p-[10px] !z-20 w-full xl:w-auto">
          <div class="wrapper bg-black !rounded-none xl:!rounded-[5px]">
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11.818" viewBox="0 0 10 11.818"><path id="Icon_ionic-md-notifications-outline" data-name="Icon ionic-md-notifications-outline" d="M10.653,5.434a4.107,4.107,0,0,1,.679.127A2.9,2.9,0,0,1,13.539,8.4v3.625l.265.266.221.222h-6.8l.221-.222.265-.266V8.4A2.9,2.9,0,0,1,9.917,5.561a5.029,5.029,0,0,1,.679-.127m.028-2.059a.869.869,0,0,0-.882.886v.414A3.83,3.83,0,0,0,6.8,8.4v3.25L5.625,12.83v.591h10V12.83l-1.176-1.182V8.4a3.83,3.83,0,0,0-2.941-3.723V4.261a.869.869,0,0,0-.882-.886ZM11.8,14.011H9.449a1.176,1.176,0,1,0,2.353,0Z" transform="translate(-5.625 -3.375)" fill="#fff" /></svg>
            <Link class="relative w-[calc(100%_-_45px)] sm:w-auto" :href="`/news/release/${props.news[0].newsSlug}`" @click="newsVisible = false">
              <p class="!font-normal ml-[2px] mr-[10px] whitespace-nowrap overflow-hidden text-ellipsis [-webkit-text-overflow: ellipsis] [-o-text-overflow]">{{ props.news[0].newsTitle }}</p>
            </Link>
            <ButtonClose class="white" @click="onClose" />
          </div>
        </div>
      </template>

      <div class="fixed">
        <!-- success -->
        <template v-if="show && $page.props.flash.success">
          <div class="wrapper bg-afgreen-light">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><polygon points="0 11 2 9 7 14 18 3 20 5 7 18" /></svg>
            <p>{{ $page.props.flash.success }}</p>
            <ButtonClose class="white" @click="show = false" />
          </div>
        </template>

        <!-- error -->
        <template v-if="show && ($page.props.flash.error || Object.keys($page.props.errors).length > 0)">
          <div class="wrapper bg-red-600">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm1.41-1.41A8 8 0 1 0 15.66 4.34 8 8 0 0 0 4.34 15.66zm9.9-8.49L11.41 10l2.83 2.83-1.41 1.41L10 11.41l-2.83 2.83-1.41-1.41L8.59 10 5.76 7.17l1.41-1.41L10 8.59l2.83-2.83 1.41 1.41z" /></svg>
            <p v-if="$page.props.flash.error">{{ $page.props.flash.error }}</p>
            <p v-else>
              <span v-if="Object.keys($page.props.errors).length === 1">フォームエラーが1つあります。</span>
              <span v-else>フォームエラーが{{ Object.keys($page.props.errors).length }}個あります。</span>
            </p>
            <ButtonClose class="white" @click="show = false" />
          </div>
        </template>
      </div>
    </div>
  </template>
</template>
